import { LegalText, SectionWrapper } from '../Shared/components';
import {
  cssSpacing,
  screenMdMin,
  screenSmMin,
  Text,
} from '@spotify-internal/encore-web/core';
import styled from 'styled-components';

export const HeroContainer = styled(SectionWrapper)`
  @media (min-width: ${screenSmMin}) {
    min-height: auto;
  }
`;

export const HeaderText = styled(Text)`
  text-wrap: wrap;
  margin: 0 0 ${cssSpacing('tighter-2')};
`;

export const SubheaderText = styled(Text)`
  font-size: 16px;
  font-weight: 400;
  margin: 0;

  @media (min-width: ${screenMdMin}) {
    font-size: 24px;
    font-weight: 700;
  }
`;

export const StyledLegalText = styled(LegalText)`
  @media (min-width: ${screenSmMin}) {
    font-size: 16px;
  }
`;

export const LegalContainer = styled.footer`
  margin-top: 32px;
`;
